// removed by extract-text-webpack-plugin
module.exports = {"controls":"VehicleCollision-hashed__controls__dqQQZ","car__wrapper":"VehicleCollision-hashed__car__wrapper__1PVFa"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/directives/VehicleCollision-hashed.scss
// module id = 1163
// module chunks = 0